import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Button, Icon } from 'antd';
import { validation_rules } from '../../../../shared/validation_rules';

const validation_message = {
    color: 'red', margin: '0 13% 1% 0', fontStyle: 'italic', fontSize: 12,
};
const default_view = {
    display: 'block', textAlign: 'center', fontStyle: 'italic', paddingTop: '1%',
};

export default connect()(class ProfilePassword extends Component {
  state = {
      password: '',
      passwordVisibility: false,
  };

  editUserPassword = event => this.setState({ password: event.target.value });

  changeUserPassword = () => {
      const { dispatch, id } = this.props; const
          { password } = this.state;
      dispatch({ type: 'CHANGE_USER_PASSWORD_REQUEST', params: { user_id: id, password } });
      this.setState({ password: '' });
  };

  showPassword = () => this.setState({ passwordVisibility: !this.state.passwordVisibility });

  render() {
      const { password, passwordVisibility } = this.state; const
          { create_password } = validation_rules;
      return (
          <div style={default_view}>
              You could change password for this user
              {' '}
              <br />
              <br />
              <Input
                  type={(password && !passwordVisibility) ? 'password' : 'text'}
                  style={{ width: '25%' }}
                  value={password}
                  maxLength={10}
                  suffix={(
                      <Icon
                          type={!passwordVisibility ? 'eye' : 'eye-invisible'}
                          onClick={this.showPassword}
                          style={{ color: 'rgba(0,0,0,.25)' }}
                      />
                  )}
                  onChange={this.editUserPassword}
                  placeholder="Example: 123asdf!@#"
              />
              <Button
                  type="primary"
                  // disabled={create_password(password)}
                  style={{ marginLeft: '2%' }}
                  onClick={this.changeUserPassword}
              >
                  Change
              </Button>
              {/* <div style={validation_message}>{password && create_password(password)}</div> */}
          </div>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/components/ProfilePassword.js